module.exports = __webpack_public_path__ + "img/title05_solgan_m.1ddccd7d.png";